import React, { useState, useEffect } from "react";

const WspolnotyStawkiCO = props => {

    const { wspolnota, mieszkancy, udzialyKontaAkt, grupy } = props;

    const [ koszty, setKoszty ] = useState({
        fv_od: "",
        fv_do: "",
        koszty_stale: 0,
        energia_pobrana: 0,
        l_zuzytych_gj: 0
    });

    return (
        <div className="stawkiContainer co">
            xx
            <div className="form">
                <div className="wiersz">
                    <label htmlFor="fv_od">Data od: </label>
                    <input id="fv_od" type="date" value={koszty.data_od} />
                </div>
                <div className="wiersz">
                    <label htmlFor="fv_do">Data do: </label>
                    <input id="fv_do" type="date" value={koszty.data_do} />
                </div>
                <div className="wiersz">
                    <label htmlFor="koszty_stale">Koszty stałe: </label>
                    <input id="koszty_stale" type="number" value={koszty.koszty_stale} />
                </div>
                <div className="wiersz">
                    <label htmlFor="energia_pobrana">Energia pobrana na c.o.: </label>
                    <input id="energia_pobrana" type="number" value={koszty.energia_pobrana} />
                </div>                
            </div>

        </div>
    )
}

export default WspolnotyStawkiCO;